module.exports = __webpack_public_path__ + "assets/icons/ic_library_books_24px.svg";